import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const TRANSACTION_NAME = environment.elasticAPM.transactionName;

@Injectable()
export class SimulationFeedbackService {
    simulationUrl = `${environment.api.endpoint}/SimulationFeedback`;
    participantUrl = `${environment.api.endpoint}/Participant`;

    private getBySimulationSub$ = new Subject<any>();
    private addSub$ = new Subject<any>();
    private updateSub$ = new Subject<any>();
    private deleteSub$ = new Subject<any>();

    constructor(private httpClient: HttpClient) {}

    getBySimulation(simulationId: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'get By Simulation' });
        return this.httpClient
            .post(
                `${this.simulationUrl}/GetBySimulation`,
                { simulationId },
                {
                    headers,
                },
            )
            .pipe(
                tap(result => {
                    if (result) {
                        this.getBySimulationSub$.next(result);
                    }
                }),
            );
    }
    getListParticipant(simulationId: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'get ListParticipant By Simulation' });
        return this.httpClient
            .post(
                `${this.participantUrl}/Gets`,
                { simulationId },
                {
                    headers,
                },
            )
            .pipe(
                tap(result => {
                    if (result) {
                        this.getBySimulationSub$.next(result);
                    }
                }),
            );
    }
    getBySimulationForParticipantId(simulationId: any, participantId: string): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'get By Simulation' });
        return this.httpClient
            .post(
                `${this.simulationUrl}/GetBySimulation`,
                { simulationId, participantId },
                {
                    headers,
                },
            )
            .pipe(
                tap(result => {
                    if (result) {
                        this.getBySimulationSub$.next(result);
                    }
                }),
            );
    }
    add(data: any): Observable<any> {
        return this.httpClient.post(`${this.simulationUrl}/Add`, data).pipe(
            tap(result => {
                if (result) {
                    this.addSub$.next(result);
                }
            }),
        );
    }

    delete(data: any): Observable<any> {
        return this.httpClient.post(`${this.simulationUrl}/Delete`, data).pipe(
            tap(result => {
                if (result) {
                    this.deleteSub$.next(result);
                }
            }),
        );
    }

    update(data: any): Observable<any> {
        return this.httpClient.post(`${this.simulationUrl}/Update`, data).pipe(
            tap(result => {
                if (result) {
                    this.updateSub$.next(result);
                }
            }),
        );
    }
    saveFeedbackAfterEdit(items: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Update multiple feedback' });
        return this.httpClient.post(
            `${this.simulationUrl}/UpdateMultiple`,
            {
                items,
            },
            { headers },
        );
    }

    addComment(data: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Add multiple feedback' });
        return this.httpClient.post(
            `${this.simulationUrl}/AddMultiple`,
            {
                feedbacks: data,
            },
            { headers },
        );
    }
    // publicFeedBack(data: any): Observable<any> {
    //     const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Add multiple feedback' });
    //     return this.httpClient.post(
    //         `${this.simulationUrl}/AddMultiple`,
    //         {
    //             feedbacks: data,
    //         },
    //         { headers },
    //     );
    // }
}
